import React, { useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { loadGapiInsideDOM, loadAuth2 } from "gapi-script";
import { actionGoogleLogin } from "../../../api/postApi";
import { MD5 } from "crypto-js";
import { useDispatch } from "react-redux";
import { loading, loadingDestroy, notice } from "../../../redux/action/action";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";
import { InitializeApi } from "../../../api/initializeApi";
import useGetAgentName from "../../../hook/useGetAgentName";
import { FcGoogle } from "react-icons/fc";
import { useTranslation } from "react-i18next";
import useCookiesAgentName from "./useCookiesAgentName";

const GoogleLogin = ({ setButtonLoading, buttonLoading }) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const [user, setUser] = useState(null);
  const [gapi, setGapi] = useState(null);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const agentName = useGetAgentName();

  const cookiesFromAgent = useCookiesAgentName();

  useEffect(() => {
    const loadGapi = async () => {
      const newGapi = await loadGapiInsideDOM();
      setGapi(newGapi);
    };
    loadGapi();
  }, []);

  useEffect(() => {
    if (!gapi) return;

    const setAuth2 = async () => {
      const auth2 = await loadAuth2(
        gapi,
        "307325716994-3rhn5npsg507np0ni4m6e69hacigm6hq.apps.googleusercontent.com",
        "profile"
      );
      if (auth2.isSignedIn.get()) {
        updateUser(auth2.currentUser.get());
      } else {
        attachSignin(document.getElementById("customBtn"), auth2);
      }
    };
    setAuth2();
  }, [gapi]);

  useEffect(() => {
    if (!gapi) return;

    if (!user) {
      const setAuth2 = async () => {
        const auth2 = await loadAuth2(
          gapi,
          "307325716994-3rhn5npsg507np0ni4m6e69hacigm6hq.apps.googleusercontent.com",
          "profile"
        );
        attachSignin(document.getElementById("customBtn"), auth2);
      };
      setAuth2();
    }
  }, [user, gapi]);

  const updateUser = (currentUser) => {
    const name = currentUser.getBasicProfile().getName();
    const profileImg = currentUser.getBasicProfile().getImageUrl();
    const email = currentUser.getBasicProfile().getEmail();
    const userId = currentUser.getId();
    setUser({
      name: name,
      profileImg: profileImg,
      email: email,
      userId: userId,
    });
  };

  const attachSignin = (element, auth2) => {
    auth2.attachClickHandler(
      element,
      {},
      (googleUser) => {
        updateUser(googleUser);
        const randomNumber = Math.random().toString().slice(2, 14);
        dispatch(loading());
        setButtonLoading(true);

        actionGoogleLogin({
          user_id: googleUser.getId(),
          emailAddress: googleUser.getBasicProfile().getEmail(),
          unlimit_code: "",
          invite: cookiesFromAgent,
          s_auth: randomNumber,
          r_auth: MD5(`Tgs${randomNumber}mov9191Login`).toString(),
        })
          .then((data) => {
            if (data.message === "Sign up success.") {
              actionGoogleLogin({
                user_id: googleUser,
                emailAddress: googleUser.getBasicProfile().getEmail(),
                unlimit_code: "",
                invite: "",
                s_auth: randomNumber,
                r_auth: MD5(`Tgs${randomNumber}mov9191Login`).toString(),
              }).then((data) => {
                if (Cookies.get("token")) {
                  Cookies.remove("token");
                }
                Cookies.set("token", data.token, { expires: 3 });
                dispatch({
                  type: "INITIALIZE_API",
                  navigate: navigate,
                  tmpToken: data.tmpToken,
                });
                navigate("/casino");
              });
            } else {
              if (Cookies.get("token")) {
                Cookies.remove("token");
              }
              Cookies.set("token", data.token, { expires: 3 });
              dispatch({
                type: "INITIALIZE_API",
                navigate: navigate,
                tmpToken: data.tmpToken,
              });
              navigate("/casino");
            }
          })
          .catch((err) => {})
          .finally(() => {
            setButtonLoading(false);
            dispatch(loadingDestroy());
          });
      },
      (error) => {
        console.log(JSON.stringify(error));
      }
    );
  };

  const signOut = () => {
    const auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(() => {
      setUser(null);
    });
  };
  return (
    <button
      icon
      type="button"
      id="customBtn"
      loading={buttonLoading}
      labelPosition="left"
      className="w-full !mt-[15px] flex items-center rounded-[5px] font-medium bg-white border gap-[10px] justify-center text-base-dark !py-[13px]"
      onClick={() => {
        // handleLogin();
      }}
    >
      <FcGoogle className="text-xl" />
      {i18n_common("signInWithGoogle")}
    </button>
  );
};

export default GoogleLogin;
